import { Link, useSearchParams } from 'react-router-dom';
import { PATHS } from 'src/actuators/common/types/Paths';
import { LocationState } from 'src/actuators/LocationState';
import { Button } from 'src/modules/common/components/Button/Button';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';

type Props = {
    label: string;
    locationState: LocationState;
    currentPage: number;
}

export const ActuatorsSelectActuatorButton = ({ label, locationState, currentPage }: Props) => {
    const [searchParams] = useSearchParams();

    return (
        <Button
            as={Link}
            className="vss-actuators-select-actuator-button"
            to={{
                pathname: [
                    PATHS.Accessories,
                    encodeURIComponent(label),
                    '1',
                ].join('/'),
                search: searchParams.toString(),
            }}
            state={{
                ...locationState,
                actuatorLabel: label,
                actuatorPage: currentPage.toString(),
                selectedAccessories: [],
                qty: 1,
            }}
            disabled={label.length < 2}
            icon={(
                <div className="vss-actuators-select-actuator-button__icon">
                    <ArrowRightIcon/>
                </div>
            )}
        >
            <I18n messageId={MESSAGES.selectDevice}/>
        </Button>
    );
};
